export const RegularTextIcon = ({
  size = 16,
  color = 'currentColor',
  ...rest
}: {
  size?: number;
  color?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}>
    <g clipPath="url(#regular-text-clip)">
      <path
        fill={color}
        d="M3.269 2.85h1.876L7.819 13h-1.54L5.6 10.354H2.716L2.065 13H.602zm2.086 6.3L4.256 4.334h-.112L3.059 9.15zm6.371 3.99q-.77 0-1.323-.266a1.93 1.93 0 0 1-.846-.763q-.288-.504-.287-1.197 0-1.477 1.162-2.023t2.862-.546h.833v-.35q0-.622-.322-1.134-.321-.51-1.28-.511a2.6 2.6 0 0 0-.799.119 3 3 0 0 0-.644.273q-.273.154-.693.434l-.678-.945q.643-.476 1.316-.756.678-.28 1.645-.28 1.68 0 2.26.833.582.833.582 1.96v2.821q0 .938.133 2.191h-1.393q-.03-.3-.056-.791l-.014-.231a2.1 2.1 0 0 1-1.015.889 3.7 3.7 0 0 1-1.443.273m.357-1.071q1.057 0 1.547-.707t.49-1.939l-.531-.014q-1.037 0-1.68.147-.637.147-.946.462-.3.315-.3.833 0 .63.377.924.386.294 1.044.294"
      />
    </g>
    <defs>
      <clipPath id="regular-text-clip">
        <path fill={color} d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
